import { inject } from '@angular/core';
import {
  DEFAULT_USER,
  UserDto,
  UserDtoWithProfilePictureBuffer,
} from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { IDeleteGateway, IGetGateway } from '../../gateways';

export class UserGateway
  implements
    IGetGateway<never, IApiResponse<UserDto>>,
    IDeleteGateway<UserDto, IApiResponse<UserDto>>
{
  private readonly configService: AppConfigService = inject(AppConfigService);
  private restCallBuilder: RestCallBuilder<UserDto> =
    new RestCallBuilder<UserDto>(DEFAULT_USER);
  private putRestCallBuilder: RestCallBuilder<FormData, UserDto> =
    new RestCallBuilder<FormData, UserDto>(DEFAULT_USER);

  get(): Observable<IApiResponse<UserDto | UserDtoWithProfilePictureBuffer>> {
    return this.restCallBuilder
      .getExternal(`${this.configService.get().general.userServiceUrl}/user/me`)
      .handleMessages()
      .build();
  }

  delete(query: UserDto): Observable<IApiResponse<UserDto>> {
    return this.restCallBuilder
      .deleteExternal(
        `${this.configService.get().general.userServiceUrl}/user/` +
          query.userId
      )
      .handleMessages()
      .build();
  }

  put(formData: FormData): Observable<IApiResponse<UserDto>> {
    return this.putRestCallBuilder
      .putExternal(
        this.configService.get().general.userServiceUrl + '/user',
        formData
      )
      .handleMessages()
      .build();
  }
}
